import {SET_DISCOUNT_CODE} from "../actions";

export default function discountCodeReducer(state = null, action) {
    switch (action.type) {
        case SET_DISCOUNT_CODE:
            return action.payload;
        default:
            return state;
    }
}